import { render, staticRenderFns } from "./GameServer.vue?vue&type=template&id=352cba96&"
import script from "./GameServer.vue?vue&type=script&lang=js&"
export * from "./GameServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports